import React, { useState, useEffect, useRef } from "react";
import Pikaday from "pikaday";

const Form = ({ config }) => {
		
	const datepicker = useRef();
	const form = useRef();
	
	const [ pax, setPax ] = useState( 12 )
	const [ date, setDate ] = useState( false )
	const [ nights, setNights ] = useState( config.hotelChoice == 'user-select' ? 2 : 0 )
	const [ error, setError ] = useState( false )
	const [ errorFields, setErrorFields ] = useState( [] )
	
	useEffect(() => {
		const picker = new Pikaday({
            field: datepicker.current,
            format: 'DD/MM/YYYY',
            onSelect: () => {
            	setDate( picker.toString() );
            }
        })
	}, [])
		
	const renderPax = (min, max) => {
		let options = [];
		for(let i=min; i<=max; i++){
			options.push(<option key={`pax-option-${i}`} value={i}>{i} guests</option>);
		}
		return options;
	}
	
	const validate = ( e ) => {
		e.preventDefault();

		const errors = [];
		const fields = [];
		setError( false );
		setErrorFields( [] );

		if( pax < 3 || pax > 50 ){
			errors.push('Please select a group size between 3 and 50');
			fields.push('pax');
		}

		if( !date ){
			errors.push('Please select a date');
			fields.push('date');
		}

		if( config.hotelChoice == 'user-select' && nights == 0 ){
			errors.push('Please select the number of nights');
			fields.push('nights');
		}
		if( errors.length > 0 ) {
			setError( errors.join('<br>') );
			setErrorFields( fields );
			return;
		} else {
			form.current.submit()
		}
	}

	const showHotelChoice = config.hotelChoice && config.data.frmHotelId > 0 ? true : false
	
	return (
		<form action={config.action} className="mod-byo" method="post" id="quote-form" onSubmit={validate} ref={form}>
			{error ? (<div className="error" dangerouslySetInnerHTML={{__html: error}}></div>) : null}
			<div className="full-width-block">
				<div className="row no-padding">
					<div className="align-content grid wrap-mobile">
						<div className={`grid-item ${showHotelChoice ? 'one-third' : 'one-half'}`}>
							<label htmlFor="frmPax" className="form-label">
							<span>Estimated group size:</span>
							<select
								name="frmPax"
								className={errorFields.includes('pax') ? 'form-select full-width radius mg-b-tch error' : 'form-select full-width radius mg-b-tch'}
								value={pax}
								onChange={( e ) => { setPax( parseInt( e.target.value ) ) }}
							>
								{renderPax(3, 50)}
							</select>
							</label>
						</div>
				
						{showHotelChoice ? (
							<HotelChoice 
								config={config} 
								nights={nights}
								setNights={setNights} 
								errorFields={errorFields} 
							/>
						) : null}
				
						<div className={`grid-item ${showHotelChoice ? 'one-third' : 'one-half'}`}>
							<label htmlFor="frmDate" className="form-label">
							<span>Ideal start date:</span>
							<input 
								className={errorFields.includes('date') ? 'form-input radius error' : 'form-input radius'}
								name="frmDate" 
								type="text" 
								placeholder="choose the start date" 
								id="datepicker" 
								ref={datepicker}
							/>
							</label>
						</div>
					</div>
				</div>
			</div>
				
			<div className="full-width-block">
				<div className="row no-padding">
					<div className="column">
						<button 
							type="submit" 
							className="button primary radius center fill-mob" 
							value="Get your quote" 
							name="btnSubmit"
						>
							Get your quote <span className="icon icon-chevron-bold-right white right"></span>
						</button>
					</div>
				</div>
			</div>
			
		{Object.entries( config.data ).map(([key, value]) => (
			<input type="hidden" name={key} value={value} key={`input-${key}`} />
		))}
		</form>
	)
}


const HotelChoice = ({ config, nights, setNights, errorFields }) => {
	return (
		<div className="full-width-block">
			<div className="row no-padding">
				<div className="column">
					<label htmlFor="frmHotel" className="form-label">
						<span>Hotel choice:</span>
						<select 
							name="frmNights" 
							className={errorFields.includes('nights') ? 'form-select full-width radius mg-b-tch error' : 'form-select full-width radius mg-b-tch'}
							value={nights}
							onChange={( e ) => { setNights( parseInt( e.target.value ) ) }}
						>
							{config.hotelChoice == 'named' ? (
								<NamedHotelChoice allowedNights={config.allowedNights} />
							):(
								<UserHotelChoice />
							)}
						</select>
					</label>
				</div>
			</div>
		</div>
	)
}

const NamedHotelChoice = ({ allowedNights }) => {
	return (
		<>
		<option value="0">Not Required</option>
		{allowedNights.map((night, index) => (
			<option key={`hotel-option-${index}`} value={night}>{formatnights(night)}</option>
		))}
		</>
	)
}

const UserHotelChoice = () => {
	let options = [];
	for(let i=1; i<=4; i++){
		options.push(<option key={`night-option-${i}`} value={i}>{formatnights(i)}</option>);
	}
	return options;
}

const formatnights = (nights) => {
	let prefix = null
	if( nights == 1 ) {
		prefix =  ' night'
	} else {
		prefix = nights == 4 ? '+ nights' : ' nights'
	}
	return nights + prefix
}

export default Form;